module.exports = __webpack_public_path__ + "img/21.06f316b9.jpg";